/**
 * Cross-app palette tuples.
 *
 * Each palette is a 10-step ramp (Mantine's `MantineColorsTuple` layout)
 * ordered light → dark. We keep the palette choice DATA here so both
 * apps agree on the same hex values even though they theme differently:
 *   - operations-console pairs with `navy` (professional, calm)
 *   - public-portal pairs with `sunny` + `teal` (arcade / energetic)
 *
 * Adding a new venue type later means adding a new palette here, NOT
 * editing the Mantine theme in each app. Same source of truth for
 * marketing sites / print material / Figma tokens in future.
 */

export type Palette10 = readonly [
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
];

export const navy: Palette10 = [
  '#eef3fb',
  '#d6e1f3',
  '#adc1e5',
  '#82a0d7',
  '#5a84cb',
  '#3a6dc3',
  '#2c5dac',
  '#22498a',
  '#1a3a70',
  '#102a55',
] as const;

export const sunny: Palette10 = [
  '#fff5eb',
  '#ffe3c5',
  '#ffc888',
  '#ffae4f',
  '#ff9a27',
  '#f78910',
  '#dc7709',
  '#b35f02',
  '#8d4a03',
  '#5f3104',
] as const;

export const teal: Palette10 = [
  '#e6fbf7',
  '#caf2e9',
  '#97e3d3',
  '#60d4bd',
  '#34c6ab',
  '#1ebf9e',
  '#0db790',
  '#009a79',
  '#007a60',
  '#005946',
] as const;

export const slate: Palette10 = [
  '#f5f8fd',
  '#eceff3',
  '#dde3ec',
  '#c4cdda',
  '#8c98a9',
  '#5d6b80',
  '#3d4a5c',
  '#26313f',
  '#1a2230',
  '#0f1622',
] as const;
